import { useMediaQuery } from '../../../hooks/useMediaQuery';
import AdvisorPanelDesktop from './AdvisorPanelDesktop';
import AdvisorPanelMobile from './AdvisorPanelMobile';

interface AdvisorPanelProps {
  name: string;
  phone: string;
}

const AdvisorPanel = ({ name, phone }: AdvisorPanelProps) => {
  const isDesktop = useMediaQuery('(min-width: 768px)');

  if (isDesktop) {
    return <AdvisorPanelDesktop name={name} phone={phone} />;
  }

  return <AdvisorPanelMobile name={name} phone={phone} />;
};

export default AdvisorPanel;
